var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarAlt = function SvgStarAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "starAlt_svg__a",
    d: "M0 0h27v25.73H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "translate(10.496 11.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "starAlt_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#starAlt_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.647 9.537c.34.029.477.45.219.674l-6.63 5.725a.799.799 0 0 0-.255.786l2 8.533a.384.384 0 0 1-.573.416l-7.496-4.538a.794.794 0 0 0-.836.007l-7.483 4.532a.384.384 0 0 1-.574-.416l2.001-8.533c.081-.347-.058-.615-.302-.825L.134 10.21a.385.385 0 0 1 .219-.674l8.727-.733c.377-.032.574-.26.701-.565L13.146.236a.384.384 0 0 1 .708 0l3.397 8.08a.8.8 0 0 0 .67.486z",
    mask: "url(#starAlt_svg__b)"
  })))));
};
export default SvgStarAlt;